import { DatePipe } from "@angular/common";
import { Component, computed, inject, input, OnInit, output } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FaIconLibrary, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faCircle, faTimeline } from "@fortawesome/free-solid-svg-icons";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";

import { TranslateTokenPipe } from "../../../../core/pipes";
import { Constants } from "../../../constants/constants";
import { BaseMilestoneModel, BaseProjectModel } from "../../../models";
import { ProgressNumberComponent, TimelineBarComponent } from "../../general";

@Component({
  selector: "adaa-tp-timeline",
  imports: [
    RouterModule,
    TranslatePipe,
    FontAwesomeModule,
    TranslateTokenPipe,
    ProgressNumberComponent,
    TimelineBarComponent,
  ],
  providers: [DatePipe],
  templateUrl: "./tp-timeline.html",
  styleUrl: "./tp-timeline.scss",
})
export class TpTimelineComponent implements OnInit {
  private readonly _translateService = inject(TranslateService);
  private readonly _datePipe = inject(DatePipe);
  private readonly _iconLibrary = inject(FaIconLibrary);

  project = input.required<BaseProjectModel>();
  milestones = input.required<BaseMilestoneModel[]>();
  useDs3Props = input<boolean>(false);
  milestonesTitle = input<string>("national_projects.main_executive_milestones");
  mainAchievementsClicked = output<BaseMilestoneModel>();
  milestoneClicked = output<BaseMilestoneModel>();

  Constants = Constants;

  dateProps = computed<{
    startDate: "startDate" | "plannedStartDate";
    endDate: "endDate" | "plannedEndDate";
  }>(() => {
    return {
      startDate: this.useDs3Props() ? "startDate" : "plannedStartDate",
      endDate: this.useDs3Props() ? "endDate" : "plannedEndDate",
    };
  });

  range = computed(() => {
    const project = this.project();
    const { startDate, endDate } = this.dateProps();

    return { start: project[startDate], end: project[endDate] };
  });

  public ngOnInit(): void {
    this._iconLibrary.addIcons(faTimeline, faCircle);
  }

  public getTitle(startDate?: number, endDate?: number, isActual: boolean = false): string {
    let tooltip: string = this._translateService.instant(
      isActual ? "national_projects.actual" : "national_projects.planned"
    );
    if (startDate)
      tooltip += `\n${this._translateService.instant("common.form.label.start_date")}: ${this._datePipe.transform(startDate, Constants.normalDate)}`;
    if (endDate)
      tooltip += `\n${this._translateService.instant("common.form.label.end_date")}: ${this._datePipe.transform(endDate, Constants.normalDate)}`;
    return tooltip;
  }
}
